import {Component, OnInit, ViewChild} from '@angular/core';
import { GenericModalService } from '../../../services/generic-modal.service';
import { PaginationInstance } from 'ngx-pagination';
import { WebClientConfigurationService } from '../../../services/configuration/web-client-configuration.service';
import {WfTableComponent} from '../../../common/table-sort/wf-table.component';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {NodeConfigurationService} from '../../../services/configuration/node-configuration.service';
import {EnumTranslateService} from '../../../services/enumTranslate-service';
import {UserModalComponent} from '../../Admin/users/user-modal.component';
import {ServiceConfigurationApiComponent} from '../service-configuration-api/service-configuration-api.component';
import {ServiceConfigurationRuntimeComponent} from '../service-configuration-runtime/service-configuration-runtime.component';
import {ServiceConfigurationInMemoryComponent} from '../service-configuration-inMemory/service-configuration-inMemory.component';
import {ServiceConfigurationSchedulerComponent} from '../service-configuration-scheduler/service-configuration-scheduler.component';
import {ServiceConfigurationBatcherComponent} from '../service-configuration-batcher/service-configuration-batcher.component';
import {ServiceConfigurationWebClientComponent} from '../service-configuration-webClient/service-configuration-webClient.component';
import {StyleBuilder} from '../../../services/style-builder';

@Component({
  selector: 'app-service-configuration-list',
  templateUrl: './service-configuration-list.component.html',
  styleUrls: ['./service-configuration-list.component.css']
})
export class ServiceConfigurationListComponent implements OnInit {

  onlyActive: boolean;
  componentList: any[];

  filterText: string;

  pleaseWait = false;
  errorMessage = '';
  config: PaginationInstance;
  destApiComponent: any = ServiceConfigurationApiComponent;
  destRuntimeComponent: any = ServiceConfigurationRuntimeComponent;
  destInMemoryComponent: any = ServiceConfigurationInMemoryComponent;
  destSchedulerComponent: any = ServiceConfigurationSchedulerComponent;
  destBatcher: any = ServiceConfigurationBatcherComponent;
  destWebClient: any = ServiceConfigurationWebClientComponent;
  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;

  constructor(
    private nodeConfigService: NodeConfigurationService,
    private modalService: GenericModalService,
    private styleBuilder: StyleBuilder, public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.onlyActive = true;
    this.pleaseWait = true;
    this.nodeConfigService.getAll()
      .subscribe(configs => {
          this.componentList = configs;
          this.componentList.forEach(c => {
            c.typeDescription = EnumTranslateService.getEnumNodeType(c.type);
          });
          this.pleaseWait = false;
        },
        error1 => {
          this.pleaseWait = false;
          this.errorMessage = error1;
        });
  }


  editNodeCofiguration(config) {
    if (config.type == 2) {
      this.modalService.showObjModal(this.destApiComponent, 'Configurações API', config, 'modal-xl');
    } else if (config.type == 1) {
      this.modalService.showObjModal(this.destRuntimeComponent, 'Configurações Runtime', config, 'modal-xl');
    } else if (config.type == 9) {
      this.modalService.showObjModal(this.destInMemoryComponent, 'Configurações Centralizador de Dados', config, 'modal-xl');
    } else if (config.type == 7) {
      this.modalService.showObjModal(this.destSchedulerComponent, 'Configurações Agendador', config, 'modal-xl');
    } else if (config.type == 10) {
      this.modalService.showObjModal(this.destBatcher, 'Configurações do Executor de Lote', config, 'modal-lg');
    } else if (config.type == 3) {
      const result$ = this.modalService.showObjModal(this.destWebClient, 'Configurações Web Client', config, 'modal-xl');
      result$.asObservable()
        .subscribe(
          result => {
            this.styleBuilder.setLayoutConfig();
            this.ngOnInit();
          }
        );
    }

  }
}
